import startWidget from './startWidget';
import overview from './overview';
import apply from './apply';
import checkout from './checkout';
import productComparison from './productComparison';

export { startWidget, overview, productComparison, apply, checkout };

export const layout = [
  startWidget,
  overview,
  productComparison,
  apply,
  checkout,
];
